<template>
    <v-container>
        <v-layout row wrap v-if="loading">
            <v-flex xs12 class="text-xs-center">
                <v-progress-circular
                    indeterminate
                    class="accent--text"
                    :width="7"
                    :size="70">
                </v-progress-circular>
            </v-flex>
        </v-layout>
        <v-layout row wrap v-else>
            <v-flex xs12>
                <v-card>
                    <v-card-title>
                       <h2 class="primary--text" >
                           {{
                           meetup.title
                           }}</h2>
                        <template
                            v-if="userIsCreator">
                            <v-spacer>
                            </v-spacer>
                            <app-edit-meetup-details-dialog
                            :meetup="meetup"
                            >
                            </app-edit-meetup-details-dialog>
                        </template>
                    </v-card-title>
                    <v-card-media
                            :src="meetup.imageUrl"
                            height="450px"
                    ></v-card-media>
                    <v-card-text>
                        <div class="info--text" >{{ meetup.date | date }} -
                            Where it takes place
                        </div>
                        Lorem ipsum dolor sit. Excepteur deserunt mollit anim id est laborum.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="primary">Register</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  props: ['id'],
  computed: {
    meetup() {
      const obj = this;
      const pId = obj.id;
      return this.$store.getters.loadedMeetup(pId);
    },
    userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    userIsCreator() {
      if (!this.userIsAuthenticated) {
        return false;
      }
      return this.$store.getters.user.id === this.meetup.createId;
    },
    loading() {
      return this.$store.getters.loading;
    },
  },
};
</script>

